/* projects/shared/layouts/responsive-nav-bar/nav-bar.component.scss */
nav-bar .side-nav {
  display: grid;
  width: var(--responsive-navbar-on-the-side-item-width);
  padding: var(--space-xl) 0;
  grid-template-rows: 120px 1fr auto;
}
nav-bar .side-nav .logo-container {
  height: 100%;
  display: grid;
  align-items: flex-start;
  justify-content: center;
}
nav-bar .side-nav nv-logo {
  padding-top: var(--space-m);
  display: inline-block;
  height: auto;
}
nav-bar .top-nav-controls {
  display: flex;
  justify-content: space-between;
  padding: 0 var(--space-m);
  height: 100%;
  align-items: center;
}
nav-bar .top-nav-controls .logo-container {
  display: flex;
  align-items: center;
}
nav-bar .top-nav-controls .logo-container nv-logo {
  display: inline-block;
  height: var(--space-xxxl);
  width: auto;
}
nav-bar .top-nav-controls .right-controls {
  display: flex;
  gap: var(--space-s);
}
nav-bar .top-nav-opened {
  display: grid;
  grid-template-rows: var(--space-5xl) 1fr min-content;
  grid-gap: var(--space-xl);
}
nav-bar .top-nav-opened .logo-container nv-logo {
  height: var(--space-5xl);
  transform: translate(var(--space-m), var(--space-m));
}
nav-bar .top-nav-opened family-footer {
  background-color: var(--color-blue);
}
nav-bar .top-nav-opened family-footer * {
  color: var(--color-white);
  font-size: var(--font-xs);
}
nav-bar .top-nav-opened family-footer .family-footer {
  gap: var(--space-l);
  margin-bottom: var(--space-xl);
}
/*# sourceMappingURL=nav-bar.component-FZBITKQQ.css.map */
